exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "pre[_v-68954960]{margin:0}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-68954960&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./demo/Custom.vue
 ** module id = 41
 ** module chunks = 0
 **/